// Page module: the commissioner report (reports#edit).

global.matchReport = {
  data: {},
  init: function(urls, matchId) {
    matchReport.data.urls = urls;
    matchReport.data.matchId = matchId;
    matchReport.disciplinary.bind();

    // define context
    context = $.extend(context, {
      home: {
        complaint: {},
        others: [],
        fouls: [],
        othersCount: 0
      },
      away: {
        complaint: {},
        others: [],
        fouls: [],
        othersCount: 0
      },
      // HCC and IRS in one list (MatchReviews). Defaulted here like the fouls,
      // so the getters below work on a report document written before reviews
      // existed — every report from before sep 2026 is one.
      reviews: [],
      reportJson: function() {
        return JSON.stringify(this);
      },
      isOfficialMissing: function(role) {
        return this.referees && this.referees[role] && this.referees[role].status === "missing";
      },
      // An official can have a slot and no name: picking "z licenco" sets the status
      // before the licence lookup answers, and it may answer with nothing. The three
      // guards below — no referees, no entry, status "missing" — all pass in that
      // state, so the name used to come out as `undefined + " " + undefined`.
      //
      // Half a name is no name either: "Janez undefined" is the same bug wearing a
      // first name. Same rule prematch already applies (pre_match.js#hasPersonName).
      hasOfficialName: function(role) {
        var o = this.referees && this.referees[role];
        return !!(o && o.first_name && o.last_name);
      },
      officialName: function(role) {
        if(this.isOfficialMissing(role) || !this.hasOfficialName(role)) {
          return "";
        } else {
          var s = this.referees[role].first_name + " " + this.referees[role].last_name;
          if(this.referees[role].city) {
            s += " (" + this.referees[role].city + ")";
          }
          return s;
        }
      },
      getObject: function(arr) {
        var obj = this;
        for(var key of arr) {
          obj = obj[key];
          if(!obj) break;
        }
        return obj;
      },
      shouldPersonSign: function(arr) {
        var obj = this.getObject(arr);
        return obj && obj.sig && !this.hasPersonSigned(arr);
      },
      hasPersonSigned: function(arr) {
        var obj = this.getObject(arr);
        return obj && obj.sig && obj.sig.status == 'SIGNED';
      },
      // --- locking ----------------------------------------------------------
      //
      // A signature says "this text is what I signed", so what somebody signed
      // stops being editable. Two locks, and ReportLock on the server is the one
      // that counts — this is only so the commissioner is not typing into a field
      // whose contents the next save will throw away.
      //
      //   the team's official representative signs -> that team's card
      //   the commissioner / 1st referee signs     -> the whole report
      //
      // An admin is exempt, which is the exemption they already have over a
      // report that has been closed and sent.
      isReportLocked: function() {
        if(matchReport.data.isAdmin) return false;

        return this.hasPersonSigned(['referees', this.reportSignRole()]);
      },
      isComplaintLocked: function(side) {
        if(this.isReportLocked()) return true;
        if(matchReport.data.isAdmin) return false;

        return this.hasPersonSigned([side, 'complaint', 'representative']);
      },
      // Offered only where it changes something: a complaint under a signed report
      // is opened by unlocking the report, not by unlocking the complaint.
      canUnlockComplaint: function(side) {
        return !this.isReportLocked() && this.isComplaintLocked(side);
      },
      unlockComplaint: function(side) {
        this.unlock(side, '<p><b>Odklenem pripombe?</b></p>' +
                          '<p>Pripombe so podpisane. Če jih odkleneš, bo podpis uradnega ' +
                          'predstavnika izbrisan in ga bo treba zbrati znova.</p>');
      },
      unlockReport: function() {
        this.unlock('report', '<p><b>Odklenem poročilo?</b></p>' +
                              '<p>Poročilo je podpisano. Če ga odkleneš, bo podpis izbrisan ' +
                              'in ga bo treba zbrati znova.</p>');
      },
      // The flag rides on the next save rather than being a request of its own:
      // the page PUTs the whole document anyway, and the server drops the
      // signature before it reads the document back (ReportsController#update).
      //
      // Asked with the app's own dialog, like every other question on these
      // screens (alerts.js). window.confirm is the browser's, not the program's:
      // it cannot be styled, it names the host instead of the question, and its
      // buttons say OK/Cancel where this one says what it is about to cost.
      unlock: function(what, question) {
        alerts.confirmation({
          title: 'Potrditev',
          type: 'warning',
          body: question,
          yesLabel: 'ODKLENI',
          noLabel: 'PREKLIČI',
          yesCallback: function() {
            matchReport.data.unlock = what;
            context.save();
          }
        });
      },
      personSignedText: function(arr) {
        if(this.hasPersonSigned(arr)) {
          return "PODPISANO";
        } else {
          return "ČAKA NA PODPIS";
        }
      },
      canShowQrCode: function(arr) {
        var obj = this.getObject(arr);
        return obj && obj.sig;
      },
      // SAVE FIRST, then ask for the signature.
      //
      // The pad shows the signer what they are signing (SignatureBrief), and it
      // reads the STORED document — the phone is another request. This page is
      // typed into and saved on a timer, so without this the representative was
      // shown their complaint as it stood before the last sentences were typed,
      // and the commissioner their closing opinion before they wrote it. Both
      // read as "the text does not show at all" when the field was empty at the
      // last autosave, which is the usual case: it is written and signed in one
      // sitting.
      //
      // The person is re-read inside the callback because the save is what mints
      // a replacement signature after an unlock — the uuid taken before it may
      // be the one that was just dropped.
      showQrCode: function(arr) {
        if(!this.canShowQrCode(arr)) return;

        var con = this;
        this.save(function() {
          var person = con.getObject(arr);
          if(!person || !person.sig) return;

          // pushes to the paired phone when there is one; the modal always
          // carries the QR code too (see signing.js)
          signing.request({ name: person.first_name + " " + person.last_name, uuid: person.sig.uuid }, matchReport.data.urls.signature);
        });
      },
      confirmSigned: function(uuid) {
        if(matchReport.disciplinary.owns(uuid)) {
          matchReport.disciplinary.refresh();
          var $m = $('.modal.show');
          if($m.length > 0 && $m.find('#' + uuid).length > 0) $m.modal('hide');
          return;
        }
        for(d of [ ['referees', 'report'], ['referees', 'commissioner'], ['home', 'complaint', 'representative'], ['away', 'complaint', 'representative'] ]) {
          d.push('sig');
          var sig = this.getObject(d);
          if(sig && sig.uuid == uuid) {
            this.save();
            var $modal = $('.modal.show');
            if($modal.length > 0) {
              if($modal.find('#'+uuid).length > 0) {
                $modal.modal('hide');
              }
            }
            return;
          }
        }
      },
      complaintQuestionText: function(side) {
        if(!this[side] || !this[side].complaint || !this[side].complaint.captain) {
          return "";
        }
        if(side == 'home') {
          return "Ali kapetan domačih (" + this.home.complaint.teamName + ") vlaga pritožbo?";
        } else {
          return "Ali kapetan gostov (" + this.away.complaint.teamName + ") vlaga pritožbo?";
        }
      },
      captainName: function(side) {
        if(!this[side] || !this[side].complaint.captain) {
          return "";
        }
        return this[side].complaint.captain.first_name + " " + this[side].complaint.captain.last_name;
      },
      representativeLabel: function(side) {
        if(!this[side] || !this[side].complaint.representative) {
          return "";
        }
        var s = "Uradni predstavnik"
        if(this[side] && this[side].complaint.representative && this[side].complaint.representative.role == 'coach') {
          s += " (trener)"
        }
        return s + ":";
      },
      representativeName: function(side) {
        if(!this[side] || !this[side].complaint.representative) {
          return "";
        }
        return this[side].complaint.representative.first_name + " " + this[side].complaint.representative.last_name;
      },
      addOther: function(side) {
        this[side].othersCount++;
      },
      // One of the people this club had on its bench earlier in the season: the
      // row is added and filled in one go. Nothing else about it is special —
      // it is the same row, and it can be edited or removed like any other.
      addKnownOther: function(side, index) {
        var known = ((matchReport.data.knownOthers || {})[side] || [])[index];
        if(!known || this[side].othersCount >= 6) return;

        var at = this[side].othersCount;
        this[side].others[at] = this[side].others[at] || { first_name: '', last_name: '' };
        this[side].others[at].first_name = known.first_name || '';
        this[side].others[at].last_name = known.last_name || '';
        this[side].othersCount++;
        // written straight onto the array: setContext splits its path on dots
        // only, so "others[0].first_name" would become a key of that literal name
        refreshContext();
      },
      removeOther: function(side, i) {
        this[side].others.splice(i, 1);
        this[side].others.push({first_name: '', last_name: ''});
        this[side].othersCount--;
      },
      isOtherShown: function(side, i) {
        return this[side].othersCount > i;
      },
      foulName: function(foul) {
        var fn = foul['fn'];
        if(fn == 'changeTFouls' || fn == 'changeBenchTFouls') {
          return 'teh. napaka';
        } else if(fn == 'changeEjections' || fn == 'changeBenchEjections') {
          return 'izklj. napaka';
        } else {
          return "";
        }
      },
      foulRole: function(side, i) {
        var foul = this.foulAt(side, i);
        if(!foul) return undefined;
        return foul['pid'] ? 'PLAYER' : 'COACH';
      },
      foulRoleText: function(side, i) {
        if(!this.foulAt(side, i)) return undefined;
        return this.foulRole(side, i) == 'PLAYER' ? 'igralec' : 'trener';
      },
      foulText: function(side, i) {
        var foul = this.foulAt(side, i);
        if(!foul) return "";
        // a foul row can carry an empty name (a person entered without one),
        // and an unnamed row must not take the whole report page down
        var first = foul['first_name'] || '';
        var last = (foul['last_name'] || '').toUpperCase();
        return first + " " + last + " (" + this.foulRoleText(side, i) + ") - " + this.foulName(foul);
      },
      // --- group state (redesign) ---------------------------------------
      // Which statutory groups still need the commissioner, computed from the
      // same rules Match#set_report_errors applies when Zaključi poročilo is
      // pressed — so the rail can say it BEFORE the refusal. Meta arrives via
      // matchReport.describe(); every getter tolerates its absence.
      isChecked: function(v) {
        return v === true || v === 'true';
      },
      groupCounts: function(key) {
        var open = 0, dev = 0;
        var descs = ((matchReport.data.meta || {}).groups || {})[key] || [];
        for(var d of descs) {
          var box = this.q && this.q[d.q];
          if(d.kind == 'check') {
            // a checked exception box IS the deviation being reported
            for(var a of d.answers) {
              if(box && this.isChecked(box[a])) dev++;
            }
          } else {
            var v = box && (d.sub ? box[d.sub] : box);
            if(!v) {
              if(d.required) open++;
            } else if(d.default && v != d.default) {
              dev++;
            }
          }
        }
        if(key == 'teams' && this.q && this.q.Q5) {
          // the server refuses checked "igralci" without a count (set_report_errors, Q5)
          if(this.isChecked(this.q.Q5.HOME_PLAYERS) && !(parseInt(this.q.Q5.homeCount) > 0)) open++;
          if(this.isChecked(this.q.Q5.AWAY_PLAYERS) && !(parseInt(this.q.Q5.awayCount) > 0)) open++;
        }
        return { open: open, dev: dev };
      },
      isGroupFlagged: function(key) {
        var c = this.groupCounts(key);
        return c.open + c.dev > 0;
      },
      isGroupCollapsed: function(key) {
        return !this.isGroupFlagged(key) && !(matchReport.data.expanded || {})[key];
      },
      toggleGroup: function(key) {
        matchReport.data.expanded = matchReport.data.expanded || {};
        matchReport.data.expanded[key] = !matchReport.data.expanded[key];
      },
      groupToggleLabel: function(key) {
        if(!this.isGroupCollapsed(key)) return "Strni";
        var descs = ((matchReport.data.meta || {}).groups || {})[key] || [];
        return "Podrobnosti (" + descs.length + ")";
      },
      groupFlagText: function(key) {
        var c = this.groupCounts(key);
        var parts = [];
        if(c.open > 0) parts.push(c.open + " brez odgovora");
        if(c.dev > 0) parts.push(c.dev + " " + this.slPlural(c.dev, ["odstopanje", "odstopanji", "odstopanja", "odstopanj"]));
        return parts.join(" · ");
      },
      slPlural: function(n, forms) {
        var r = n % 100;
        if(r == 1) return forms[0];
        if(r == 2) return forms[1];
        if(r == 3 || r == 4) return forms[2];
        return forms[3];
      },
      // the collapsed line: the answers the collapse is hiding, radios only —
      // an unchecked exception box says nothing worth a summary
      groupSummary: function(key) {
        var descs = ((matchReport.data.meta || {}).groups || {})[key] || [];
        var parts = [];
        for(var d of descs) {
          if(d.kind != 'radio' || !d.label) continue;
          var box = this.q && this.q[d.q];
          var v = box && (d.sub ? box[d.sub] : box);
          if(!v) continue;
          parts.push(d.label + ": " + (d.answers[v] || v));
        }
        return parts.length ? parts.join(" · ") : "Brez posebnosti.";
      },
      // one question deviates when any of its descriptors does — the tint on
      // the row itself, so the flagged card says WHICH answer needs reading
      qDeviates: function(q) {
        var descs = (matchReport.data.byQ || {})[q] || [];
        for(var d of descs) {
          var box = this.q && this.q[d.q];
          if(d.kind == 'check') {
            for(var a of d.answers) {
              if(box && this.isChecked(box[a])) return true;
            }
          } else {
            var v = box && (d.sub ? box[d.sub] : box);
            if(v && d.default && v != d.default) return true;
          }
        }
        return false;
      },
      // --- the merged people card (gledalci, osebe, statistika) -----------
      peopleFlagText: function() {
        var parts = [];
        if(this.isAttendanceOpen()) parts.push("št. gledalcev manjka");
        var n = this.othersIncomplete();
        if(n > 0) parts.push(n + " nepopolnih vnosov");
        return parts.join(" · ");
      },
      othersTotal: function() {
        return ((this.home || {}).othersCount || 0) + ((this.away || {}).othersCount || 0);
      },
      othersSummaryText: function() {
        var n = this.othersTotal();
        return n > 0 ? n + " " + this.slPlural(n, ["vpisana", "vpisani", "vpisane", "vpisanih"]) : "ni vpisanih";
      },
      // the rail says it too, so a commissioner who never scrolls past the first
      // card still learns that these people are theirs to collect
      othersRailWhy: function() {
        var n = this.othersIncomplete();
        if(n > 0) return n + " nepopolnih vnosov";
        return this.othersTotal() > 0 ? "" : "ni vpisanih — če jih ni, pusti prazno";
      },
      isOthersEditorShown: function() {
        return !!(matchReport.data.expanded || {}).others || this.othersTotal() > 0 || this.othersIncomplete() > 0;
      },
      othersToggleLabel: function() {
        // a verb, not "dopolni": the empty state is an invitation to collect them
        return this.isOthersEditorShown() ? "Skrij" : "Vpiši osebe";
      },
      // --- the fouls table (prototype: del tekme / oseba / napaka / oznaka)
      foulPartText: function(side, i) {
        var f = this.foulAt(side, i);
        if(!f) return "";
        // a row without a moment says nothing rather than "PNaN null'"
        if(!f.quarter) return "";
        var q = parseInt(f.quarter);
        var part = q <= 4 ? q + "/4" : "P" + (q - 4);
        return part + " " + f.minute + "'";
      },
      foulPersonText: function(side, i) {
        var f = this.foulAt(side, i);
        if(!f) return "";
        return ((f.first_name || '') + " " + (f.last_name || '').toUpperCase()).trim() + " · " + this.foulRoleText(side, i);
      },
      // Which foul the commissioner is labelling.
      //
      // Since the FIBA split a technical is one of two kinds, and the report has
      // to say which: the consequence differs, and the commissioner is choosing a
      // reason for THIS foul. It said "Tehnična napaka" for all of them.
      //
      // The words come from the log table's own vocabulary
      // (scoresheet.js#logs.actions) rather than a third copy of them, so the
      // report and the sheet cannot drift apart.
      //
      // Only the two kinds of the rule change carry a category. A technical
      // recorded before it has none — a match keeps the vocabulary it was played
      // under — and a bench technical is a CHARGE rather than a kind, so both keep
      // the plain word.
      CATEGORISED_FOULS: ['changeTech1Fouls', 'changeTech2Fouls'],
      foulKindText: function(side, i) {
        var f = this.foulAt(side, i);
        if(!f) return "";
        var fn = f.fn || '';
        if(fn.indexOf('Ejection') >= 0) return "Izključujoča napaka";

        if(this.CATEGORISED_FOULS.indexOf(fn) >= 0) {
          var action = ((scoresheet.data.logs || {}).actions || {})[fn];
          if(action) return action.name(f);
        }
        return "Tehnična napaka";
      },
      // --- pregled posnetka: HCC from the sheet, IRS by hand -------------------
      //
      // Two kinds of review in one array (MatchReviews), and the client treats them
      // as two tables because they are two different things to a commissioner: the
      // HCC rows ARE the match — the keeper recorded the challenge, so when and
      // whose is not the commissioner's to type, only why — and the IRS rows are
      // the commissioner's own record of what the referees reviewed.
      //
      // Addressed through getters rather than keypath bindings on an index. The
      // array is re-derived by the server on every save (a challenge taken during
      // the match appears then, one corrected on the sheet moves), so an index
      // written back from the DOM would be a row somebody else has since moved —
      // and a keypath binding writes back for every slot rendered, inventing rows
      // nobody added. Same lesson as the prematch roster.
      MAX_IRS: 10,
      reviewsOfKind: function(kind) {
        return ((this.reviews || []).filter(function(r) { return r && r.kind === kind; }));
      },
      hccAt: function(i) { return this.reviewsOfKind('HCC')[i] || null; },
      irsAt: function(i) { return this.reviewsOfKind('IRS')[i] || null; },
      isHccShown: function(i) { return !!this.hccAt(i); },
      isIrsShown: function(i) { return !!this.irsAt(i); },
      hasReviews: function() { return (this.reviews || []).length > 0; },
      hasHcc: function() { return this.reviewsOfKind('HCC').length > 0; },
      irsCount: function() { return this.reviewsOfKind('IRS').length; },
      canAddIrs: function() { return this.irsCount() < this.MAX_IRS; },
      // "3/4 7'", the same shape the technicals use
      reviewWhenText: function(r) {
        if(!r || !r.quarter) return "";
        var q = parseInt(r.quarter);
        return (q <= 4 ? q + "/4" : "P" + (q - 4)) + " " + (r.minute || '') + "'";
      },
      hccWhenText: function(i) { return this.reviewWhenText(this.hccAt(i)); },
      hccTeamText: function(i) {
        var r = this.hccAt(i);
        return r ? ((matchReport.data.teamNames || {})[r.side] || '') : '';
      },
      hccReason: function(i) {
        var r = this.hccAt(i);
        return r && r.reason ? r.reason : '';
      },
      onHccReasonChange: function(el, event, i) {
        var r = this.hccAt(i);
        if(!r) return;

        r.reason = el.value || null;
        refreshContext();
        this.save();
      },
      irsField: function(i, field) {
        var r = this.irsAt(i);
        return r && r[field] ? r[field] : '';
      },
      irsQuarter: function(i) { return this.irsField(i, 'quarter'); },
      irsMinute: function(i) { return this.irsField(i, 'minute'); },
      irsReason: function(i) { return this.irsField(i, 'reason'); },
      onIrsChange: function(el, event, i, field) {
        var r = this.irsAt(i);
        if(!r) return;

        r[field] = el.value || (field === 'reason' ? null : '');
        refreshContext();
        this.save();
      },
      addIrs: function() {
        if(!this.canAddIrs()) return;

        this.reviews = (this.reviews || []).concat([
          { kind: 'IRS', side: null, quarter: '', minute: '', reason: null }
        ]);
        refreshContext();
        this.save();
      },
      // by identity, not by index: the array holds both kinds and the HCC rows can
      // move under it between saves
      removeIrs: function(i) {
        var row = this.irsAt(i);
        if(!row) return;

        var at = (this.reviews || []).indexOf(row);
        if(at < 0) return;

        this.reviews.splice(at, 1);
        refreshContext();
        this.save();
      },
      // What still keeps the report from being closed: an HCC nobody said why
      // about, and an IRS row that is not a record of anything yet.
      unmarkedReviews: function() {
        var n = 0;
        for(var r of this.reviewsOfKind('HCC')) {
          if(!r.reason) n++;
        }
        for(var s of this.reviewsOfKind('IRS')) {
          if(!s.quarter || !s.minute || !s.reason) n++;
        }
        return n;
      },
      isHccUnmarked: function(i) {
        var r = this.hccAt(i);
        return !!r && !r.reason;
      },
      isIrsIncomplete: function(i) {
        var r = this.irsAt(i);
        return !!r && (!r.quarter || !r.minute || !r.reason);
      },
      reviewsSummaryText: function() {
        var hcc = this.reviewsOfKind('HCC').length, irs = this.irsCount();
        if(hcc + irs === 0) return "Ni pregledov posnetka.";
        return "HCC: " + hcc + " · IRS: " + irs;
      },

      // --- the rail's non-question checks, same sources as the server -----
      isAttendanceOpen: function() {
        return this.attendance === undefined || this.attendance === null || this.attendance === '';
      },
      // The disciplinary reports are their own records, not part of the document
      // this client owns — so the count is handed in from the server (like
      // knownOthers) and lives on matchReport.data, off the context that gets
      // serialised as the report. A function, not a literal in the binding: the
      // rail's expressions are pinned by report_form_bindings_test, and a literal
      // would change with the data and break that golden.
      disciplinaryOpen: function() {
        return (matchReport.data.disciplinaryDrafts || 0) > 0;
      },
      disciplinaryTag: function() {
        var n = matchReport.data.disciplinaryDrafts || 0;
        return n + (n === 1 ? ' nepodpisana' : ' nepodpisane');
      },
      // Same shape, and refreshed by every save (see the update response): the
      // referees sign the scoresheet while this page is open.
      refereeSignaturesOpen: function() {
        return (matchReport.data.unsignedReferees || []).length > 0;
      },
      refereeSignaturesWhy: function() {
        return (matchReport.data.unsignedReferees || []).join(', ');
      },
      othersIncomplete: function() {
        var n = 0;
        for(var side of ['home', 'away']) {
          var s = this[side] || {};
          for(var i = 0; i < (s.othersCount || 0); i++) {
            var o = (s.others || [])[i] || {};
            if(!o.first_name || !o.last_name) n++;
          }
        }
        return n;
      },
      unmarkedFouls: function() {
        var n = 0;
        for(var side of ['home', 'away']) {
          for(var f of (this[side] && this[side].fouls) || []) {
            // a row the DOM still holds while the array no longer does: the table
            // is about to be swapped, and a getter must not take the page down in
            // the meantime
            if(!f) continue;
            if(!f.readonly && !f.foulType) n++;
          }
        }
        return n;
      },
      foulAt: function(side, i) {
        var list = (this[side] && this[side].fouls) || [];
        return list[i] || null;
      },
      // --- one red message, one live check ------------------------------------
      //
      // The messages under a card are a server snapshot from page load, and the
      // commissioner fixes them one at a time. Bound to the card's own gate they all
      // stayed until the LAST one was done, so somebody who had just fixed four of
      // five was still reading about all five. These say, per message, whether that
      // one thing is still outstanding. Match#set_report_errors writes the call
      // beside the message it belongs to.
      isOtherIncomplete: function(side, i) {
        var s = this[side] || {};
        // a row deleted since the page loaded is not incomplete, it is gone
        if(i >= (s.othersCount || 0)) return false;
        var o = (s.others || [])[i] || {};
        return !o.first_name || !o.last_name;
      },
      // logId where the row has one — the table is re-rendered while this page is
      // open, and a foul added or removed shifts every index below it. The index is
      // the fallback for rows from before logIds.
      //
      // Deliberately the SERVER's rule (any blank type), not unmarkedFouls()' rule
      // (which also skips readonly rows): this message exists to explain a refusal,
      // and the refusal is the server's.
      isFoulUnmarked: function(side, logId, i) {
        var list = (this[side] && this[side].fouls) || [];
        var f = null;
        if(logId) {
          for(var x of list) {
            if(x && x.logId === logId) { f = x; break; }
          }
        } else {
          f = list[i];
        }
        if(!f) return false;
        return !f.foulType;
      },
      isRefereeUnsigned: function(who) {
        return (matchReport.data.unsignedReferees || []).indexOf(who) >= 0;
      },
      isDisciplinaryDraft: function(uuid) {
        return (matchReport.data.disciplinaryDraftUuids || []).indexOf(uuid) >= 0;
      },
      zoneOpen: function(side) {
        if(!(matchReport.data.meta || {}).u9_u16) return 0;
        var n = 0;
        for(var q of ['Q29', 'Q30', 'Q31']) {
          if(!(this.q && this.q[side] && this.q[side][q])) n++;
        }
        return n;
      },
      // What this team's card is still missing. `withSignature` is the card's own
      // verdict; without it, it is what has to be there BEFORE the representative
      // is asked to sign — they cannot sign their own missing signature, and
      // what they sign is frozen (ReportLock), so it must be complete first.
      complaintParts: function(side, withSignature) {
        var s = this[side] || {};
        var parts = [];
        if(!(s.complaint && s.complaint.text)) parts.push("pripombe manjkajo");
        if(withSignature && !this.hasPersonSigned([side, 'complaint', 'representative'])) parts.push("podpis predstavnika");
        var z = this.zoneOpen(side);
        if(z > 0) parts.push(z + " " + this.slPlural(z, ["vprašanje", "vprašanji", "vprašanja", "vprašanj"]) + " brez odgovora");
        return parts;
      },
      complaintWhy: function(side) {
        return this.complaintParts(side, true).join(" · ");
      },
      isComplaintOpen: function(side) {
        return this.complaintWhy(side).length > 0;
      },
      canSignComplaint: function(side) {
        return this.complaintParts(side, false).length === 0;
      },
      complaintSignTitle: function(side) {
        var parts = this.complaintParts(side, false);
        return parts.length === 0 ? 'Podpiši pripombe'
                                  : 'Najprej je treba izpolniti: ' + parts.join(' · ');
      },
      // Asked of the ENTRY and not of its signature, as ReportLock#signer_role and
      // Match#set_report_errors ask it: unlocking the report drops the signature,
      // and a slot that answered 'report' a moment ago must not start answering
      // 'commissioner' — that is somebody else's name.
      reportSignRole: function() {
        return this.referees && this.referees.report ? 'report' : 'commissioner';
      },
      isReportSignOpen: function() {
        return !this.hasPersonSigned(['referees', this.reportSignRole()]);
      },
      // Everything the report still owes, EXCEPT its own signature — which is
      // the last thing, not one among the others.
      //
      // Of the groups it asks only for answers still MISSING, the one thing
      // Match#set_report_errors refuses. A deviation — "brez izkaznice" at the
      // scorekeeper, "vplivne napake", an exception box ticked at the fans — is
      // the commissioner reporting something, not something left undone; it
      // flags the card so it is read (isGroupFlagged), and it must not hold
      // the signature. It did: a report that said anything was wrong could not
      // be signed from this screen, while the pad reached by QR code accepted
      // it, because the server never asked.
      isReportIncomplete: function() {
        if(this.isAttendanceOpen() || this.othersIncomplete() > 0 || this.unmarkedFouls() > 0) return true;
        if(this.isComplaintOpen('home') || this.isComplaintOpen('away')) return true;
        if(this.disciplinaryOpen() || this.refereeSignaturesOpen()) return true;
        for(var key of Object.keys((matchReport.data.meta || {}).groups || {})) {
          if(this.groupCounts(key).open > 0) return true;
        }
        return false;
      },
      anyGroupFlagged: function() {
        for(var key of Object.keys((matchReport.data.meta || {}).groups || {})) {
          if(this.isGroupFlagged(key)) return true;
        }
        return false;
      },
      // What the server would refuse "Zaključi poročilo" for, and the signature
      // it still waits for — the rail's hints about closing read this.
      railAllDone: function() {
        return !this.isReportIncomplete() && !this.isReportSignOpen();
      },
      // The rail lists deviations too, as things to read before closing, so
      // its heading has to stay while any card is flagged — even one the
      // server would accept as it stands.
      railNeedsAttention: function() {
        return !this.railAllDone() || this.anyGroupFlagged();
      },
      // A signature says "this IS the report". It cannot be said of a document
      // that is still missing half its answers — and a signed report is frozen
      // (ReportLock), so signing early would lock a report nobody can finish and
      // nobody can submit either. The server refuses it as well
      // (SignatureBrief::ReportSignoff#errors_for): the pad is reached by
      // scanning a QR code, and this button is not the only way to it.
      canSignReport: function() {
        return !this.isReportIncomplete();
      },
      reportSignTitle: function() {
        return this.canSignReport() ? 'Podpiši poročilo'
                                    : 'Poročilo še ni izpolnjeno — glej opozorila.';
      },
      // successCallback = tell me when THIS document is stored.
      //
      // Queued rather than held in this call, because a save already in flight
      // does not answer for the changes made since it started: the caller has to
      // wait for the follow-up save, and the old code simply dropped them on the
      // floor — the caller was never told, and never told that it would not be.
      save: function(successCallback) {
        matchReport.clearSave();
        if(successCallback) {
          matchReport.data.saveWaiting = (matchReport.data.saveWaiting || []).concat(successCallback);
        }
        if(context.saving) {
          context.saveOnSuccess = true;
          return;
        }
        context.saving = true;
        var con = context;
        $.ajax(matchReport.data.urls.save, {
          method: 'PUT',
          data: matchReport.savePayload(con),
          success: function(data) {
            var foulsBefore = matchReport.foulSignature(context);
            var reviewsBefore = context.reviews;
            $.extend(context, data.report);
            context.reviews = matchReport.mergeReviews(reviewsBefore, data.report.reviews);
            // off the context, not into it: reportJson() serialises the context as
            // the stored document, and this is the scoresheet's business
            if(data.unsignedReferees !== undefined) matchReport.data.unsignedReferees = data.unsignedReferees;
            matchReport.noteFinalWhistle(data.report);
            con.saving = false;
            var followUp = false;
            if(con.saveOnSuccess) {
              con.saveOnSuccess = false;
              followUp = true;
              con.save();
            }
            // A technical awarded since the last save is a row this page has no
            // template for — the markup comes from the server. Swapped in only
            // when the count actually changed, so a commissioner mid-select is not
            // interrupted; existing rows keep updating through their bindings.
            if(data.technicalsHtml !== undefined && matchReport.foulSignature(context) !== foulsBefore) {
              $('#technicals-table').html(data.technicalsHtml);
              Twine.reset(context).bind().refresh();
            }
            refreshContext();
            matchReport.applyLocks();
            // Only once nothing further is queued: the follow-up save is still
            // carrying these, and answering now would answer for a document that
            // is already out of date.
            if(!followUp) matchReport.drainSaveWaiting();
            matchReport.setSave();
            matchReport.reloadIfMatchEnded();
          },
          error: function() {
            // The document did not reach the server, so what the waiters get is
            // not what they asked for. They are answered anyway: they are user
            // actions waiting on a save, and a control that never answers is
            // worse than one that answers with what is on screen.
            matchReport.drainSaveWaiting();
          },
          complete: function() {
            con.saving = false;
          }
        });
      }
    });

    // get report from server
    $.ajax(matchReport.data.urls.save, {
      success: function(data) {
        matchReport.initAfterLoad(data.report);
        window.localStorage.removeItem(`scoresheet-${matchReport.data.matchId}`);
        setContext("loaded", true);
        refreshContext();
        matchReport.applyLocks();
      }
    });

  },
  savePayload: function(con) {
    var payload = { "match[report]": con.reportJson() };
    if(matchReport.data.unlock) {
      payload.unlock = matchReport.data.unlock;
      matchReport.data.unlock = null;
    }
    return payload;
  },

  // Locking is not a per-field rule, it is "this document is closed to you now",
  // so it is applied to the form as a whole rather than written onto three
  // hundred inputs as bindings.
  //
  // What stays usable inside a locked report, deliberately:
  //
  //   * the signature rows. The report cannot be signed before it is complete
  //     (canSignReport), representatives included — but reports signed before
  //     that rule existed are in the database, and one of them with an unsigned
  //     representative could never be finished if these buttons went dead too.
  //   * the unlock buttons, which are the way out.
  //   * the disciplinary card. A prijava is its own document, with its own
  //     signatures and its own lock, and the report refuses to close while one is
  //     unsigned.
  //
  // Run after every save and after the first load: a signature arrives through
  // confirmSigned, which saves, and an unlock arrives the same way.
  applyLocks: function() {
    if(typeof context.isReportLocked !== 'function') return;

    var all = context.isReportLocked();
    $('.report-main').find('input, textarea, select, button').each(function() {
      var $el = $(this);
      if($el.closest('.sig-row, #disciplinary, .js-unlock').length > 0) return;

      var card = $el.closest('.card').attr('id');
      var side = card === 'complaint-home' ? 'home' : (card === 'complaint-away' ? 'away' : null);
      $el.prop('disabled', all || (side !== null && context.isComplaintLocked(side)));
    });
  },

  // Everybody waiting to be told the document is stored, told once. Cleared
  // before the callbacks run, so one that saves again cannot be answered by its
  // own save.
  drainSaveWaiting: function() {
    var waiting = matchReport.data.saveWaiting || [];
    matchReport.data.saveWaiting = [];
    waiting.forEach(function(cb) { cb(); });
  },

  // --- the final whistle, while this page is open --------------------------
  //
  // Three of the report's cards — the two officials' complaints, the closing
  // opinion and the signature — exist only after the final whistle, and whether
  // they exist is decided ON THE SERVER when the page is rendered
  // (reports/edit.html.haml, `match_over`). The commissioner has the report open
  // through the whole match, so the page they are looking at was almost always
  // rendered before the whistle: the cards were not hidden, they were never
  // built, and not even "Shrani spremembe" could produce them. Only a manual
  // reload did, and nobody thinks to try one.
  //
  // Who owns a review row, when a save answers.
  //
  // The response carries the reviews the SERVER derived from the request — and the
  // commissioner has been typing in the meantime, because a save takes as long as
  // the hall's wifi says it does. Taking the answer whole threw away every IRS row
  // added since the request left, which is exactly what a commissioner filling in
  // three of them does.
  //
  // So each half is taken from whoever owns it: the HCC rows are the scoresheet's,
  // and only the server knows when a new challenge was recorded; the IRS rows are
  // the commissioner's, and only this page knows what they have just typed. A
  // reason already given here wins over the same row's reason in the answer, for
  // the same reason — it may have been picked after the request was sent.
  mergeReviews: function(mine, theirs) {
    if(!theirs) return mine || [];

    var mineList = mine || [];
    var hcc = theirs.filter(function(r) { return r && r.kind === 'HCC'; }).map(function(row) {
      var here = mineList.filter(function(r) {
        return r && r.kind === 'HCC' && r.logId === row.logId;
      })[0];
      if(here && here.reason) row.reason = here.reason;
      return row;
    });
    var irs = mineList.filter(function(r) { return r && r.kind === 'IRS'; });

    return hcc.concat(irs);
  },

  // The referee count and the technicals table already ride along with every
  // save for exactly this reason. These cards cannot: they are whole sections of
  // a server-rendered form. So the page reloads itself, once, at the only moment
  // that is safe — right after a successful save, with the document stored.
  noteFinalWhistle: function(report) {
    if(matchReport.data.matchOver) return;
    if(!report || !(report.matchFinished === true || report.matchFinished === 'true')) return;

    matchReport.data.matchEnded = true;
  },
  // Not while somebody is typing: the autosave fires on a timer, and reloading
  // under a cursor would swallow whatever was typed since the save. Held over to
  // the next save instead — the page is saved either way, so nothing is lost by
  // waiting.
  reloadIfMatchEnded: function() {
    if(!matchReport.data.matchEnded) return;

    var el = document.activeElement;
    if(el && /^(input|textarea|select)$/i.test(el.tagName)) return;

    matchReport.clearSave();
    window.location.reload();
  },
  // Group meta and the expanded set for the report's collapsible groups — kept
  // OUT of context on purpose: reportJson() is JSON.stringify(context), and UI
  // state must never ride into the stored report document.
  // --- the disciplinary reports, inline ------------------------------------
  //
  // The card body is server-rendered and swapped whole. It cannot be a form —
  // reports/edit is already one big form and a nested one is invalid HTML — so
  // the inputs carry no name, this reads them by class, and the server answers
  // with the same partial re-rendered. Same shape as technicalsHtml.
  disciplinary: {
    // How long to wait after the last keystroke. Shorter than the report's own 20s
    // because a prijava is typed in one sitting and then left.
    DELAY: 1500,

    bind: function() {
      $(document).on('click', '.js-disc-save', function() {
        matchReport.disciplinary.flush();
        matchReport.disciplinary.submit($(this).closest('.disc-block'));
      });
      $(document).on('click', '.js-disc-delete', function() {
        if(!window.confirm('Odstranim to prijavo?')) return;
        matchReport.disciplinary.cancel();
        matchReport.disciplinary.send('DELETE', $(this).closest('.disc-block').data('uuid'), null);
      });
      // Save first, for the same reason showQrCode does: the pad shows the
      // signer their own statement (SignatureBrief::DisciplinaryStatement) and
      // reads it from the stored prijava, while this card saves on a 1.5s timer.
      // A statement typed and signed in one movement would otherwise be handed
      // over as it was a keystroke ago, or empty.
      //
      // The uuid on the button does not move across an ordinary save:
      // DisciplinaryReport#ensure_signatures! is idempotent, and the one thing
      // that does replace a signature — unlocking a statement — takes the button
      // away with it.
      $(document).on('click', '.js-sign', function() {
        var $b = $(this);
        var req = { name: $b.data('name'), uuid: String($b.data('uuid')) };
        var ask = function() { signing.request(req, matchReport.data.urls.signature); };
        var $block = $b.closest('.disc-block[data-uuid]');
        if($block.length === 0) return ask();

        var d = matchReport.disciplinary;
        d.cancel();
        d.pending = null;
        d.submit($block, { quiet: true, then: ask });
      });

      // The form is the exception, so it stays out of the way until it is asked
      // for. The button is in the card header and never moves.
      //
      // The list of people to report is built on the server from the stored
      // document (MatchPeople), and it includes the OTHER OFFICIALS the
      // commissioner types into this very page. The card was rendered when the
      // page loaded, so anybody entered since was missing from the list and only
      // a reload brought them in — which is a poor thing to have to know while
      // filing a disciplinary report.
      //
      // Save first, THEN rebuild: the server reads the document, so rebuilding
      // before the save would produce the same stale list.
      $(document).on('click', '#disciplinary-new-btn', function() {
        context.save(function() { matchReport.disciplinary.refresh({ openNew: true }); });
      });

      // Picking the person is what starts a prijava: from here on it is saved as
      // it is typed, like everything else on this page.
      $(document).on('change', '.disc-block--new .js-disc-against', function() {
        if(!$(this).val()) return;
        matchReport.disciplinary.submit($(this).closest('.disc-block'));
      });

      // A statement is added when there is one to add. Cloned from the templates
      // in the block, so nothing is fetched and nothing on the page moves.
      $(document).on('click', '.js-disc-add', function() {
        var $btn = $(this);
        var $block = $btn.closest('.disc-block');
        var kind = $btn.data('kind');
        var $row = $block.find('.disc-templates .disc-statement[data-kind="' + kind + '"]')
                         .first().clone();

        $row.insertBefore($block.find('.disc-add'));
        if(kind === 'accused') $btn.remove();          // there is only one accused
        $row.find('.js-disc-text, .js-disc-first').filter(':visible').first().trigger('focus');
      });

      // A signed statement is somebody's word under their own name. Changing it is
      // allowed — a referee mistypes — but not by accident, and not without
      // saying what it costs.
      $(document).on('click', '.js-disc-unlock', function() {
        if(!window.confirm('Izjava je podpisana. Če jo spremeniš, bo podpis izbrisan ' +
                           'in ga bo treba zbrati znova.')) return;

        var $row = $(this).closest('.disc-statement');
        $row.find('input.js-disc-unlock').val('1');
        $row.find('.disc-statement__edit').removeClass('hide');
        $row.find('.disc-statement__text').remove();
        $(this).remove();
        $row.find('.js-disc-text').trigger('focus');
      });

      // Removing one is explicit: an empty statement left behind would be a
      // person the document says gave an account and did not.
      $(document).on('click', '.js-disc-drop', function() {
        var $row = $(this).closest('.disc-statement');
        var $block = $row.closest('.disc-block');
        if($row.find('.js-disc-text').val() && !window.confirm('Odstranim to izjavo?')) return;

        $row.remove();
        matchReport.disciplinary.queue($block);
      });

      var typed = '.disc-block[data-uuid] input, .disc-block[data-uuid] textarea, ' +
                  '.disc-block[data-uuid] select';
      $(document).on('input change', typed, function() {
        var $block = $(this).closest('.disc-block');
        $block.find('.disc-saved').addClass('hide');
        matchReport.disciplinary.queue($block);
      });

      // A save that changes the markup waits until the cursor leaves the card —
      // swapping the HTML mid-sentence would take the field out from under it.
      $(document).on('focusout', '#disciplinary', function() {
        setTimeout(matchReport.disciplinary.applyPending, 0);
      });
    },

    queue: function($block) {
      var d = matchReport.disciplinary;
      // a different block than the one waiting: save that one now rather than
      // dropping it when this timer replaces its own
      if(d.pending && d.pending.data('uuid') !== $block.data('uuid')) d.flush();
      d.cancel();
      d.pending = $block;
      d.timer = setTimeout(function() { d.flush(); }, d.DELAY);
    },

    cancel: function() {
      clearTimeout(matchReport.disciplinary.timer);
      matchReport.disciplinary.timer = null;
    },

    flush: function() {
      var d = matchReport.disciplinary;
      d.cancel();
      if(!d.pending) return;

      var $block = d.pending;
      d.pending = null;
      d.submit($block, { quiet: true });
    },

    // Swap the card only when it would say something new, and only when nobody is
    // typing in it. Held otherwise, and applied on the way out.
    applyPending: function() {
      var d = matchReport.disciplinary;
      if(!d.heldHtml) return;
      if($('#disciplinary').find(document.activeElement).length > 0) return;

      $('#disciplinary-body').html(d.heldHtml);
      d.heldHtml = null;
    },

    // Everything in the block, in the shape the controller permits.
    submit: function($block, opts) {
      var data = {
        'disciplinary_report[filer_role]': $block.find('.js-disc-filer').val(),
        'disciplinary_report[against_key]': $block.find('.js-disc-against').val(),
        'disciplinary_report[explanation]': $block.find('.js-disc-explanation').val()
      };
      $block.find('.disc-statements .disc-statement').each(function(i) {
        var $s = $(this);
        var prefix = 'disciplinary_report[statements][' + i + ']';
        data[prefix + '[kind]'] = $s.data('kind');
        data[prefix + '[first_name]'] = $s.find('.js-disc-first').val();
        data[prefix + '[last_name]'] = $s.find('.js-disc-last').val();
        data[prefix + '[text]'] = $s.find('.js-disc-text').val();
        data[prefix + '[unlock]'] = $s.find('input.js-disc-unlock').val();
      });
      var uuid = $block.data('uuid');
      matchReport.disciplinary.send(uuid ? 'PATCH' : 'POST', uuid, data,
                                    $.extend({ uuid: uuid }, opts));
    },

    send: function(method, uuid, data, opts) {
      var base = $('.disc-inline').data('url');
      if(!base) return;

      // the uuid belongs before the query string, which carries the public link
      var parts = String(base).split('?');
      var url = (uuid ? parts[0] + '/' + uuid : parts[0]) + (parts[1] ? '?' + parts[1] : '');

      $.ajax(url, {
        method: method,
        data: data,
        success: function(res) {
          matchReport.disciplinary.apply(res, opts);
          if(opts && opts.uuid) $('.disc-block[data-uuid="' + opts.uuid + '"] .disc-saved').removeClass('hide');
          // for a caller that must not act until this prijava is stored
          if(opts && opts.then) opts.then(res);
        },
        error: function(xhr) {
          var res = xhr.responseJSON || {};
          matchReport.disciplinary.apply(res, opts);
          if(!res.error) $('#disciplinary-error').text('Prijave ni bilo mogoče shraniti.').removeClass('hide');
        }
      });
    },

    // A quiet save is one the commissioner did not ask for — it must not move
    // anything. The markup is only swapped when the card would say something new
    // (a sign button that was not there), and even then applyPending holds it
    // until the cursor leaves.
    apply: function(res, opts) {
      var d = matchReport.disciplinary;
      var quiet = opts && opts.quiet;
      var before = (matchReport.data.disciplinarySignatures || []).join(',');

      if(res.signatureUuids !== undefined) matchReport.data.disciplinarySignatures = res.signatureUuids;
      if(res.drafts !== undefined) {
        matchReport.data.disciplinaryDrafts = res.drafts;
        // which ones, not just how many: the red message names a person, and it is
        // that prijava's signature that decides whether it is still true
        matchReport.data.disciplinaryDraftUuids = res.draftUuids || [];
        refreshContext();
      }

      if(res.html !== undefined) {
        var changed = res.signatureUuids === undefined || res.signatureUuids.join(',') !== before;
        if(!quiet) {
          $('#disciplinary-body').html(res.html);
          d.heldHtml = null;
        } else if(changed) {
          d.heldHtml = res.html;
          d.applyPending();
        }
      }

      var $err = $('#disciplinary-error');
      if(res.error) { $err.text(res.error).removeClass('hide'); } else { $err.addClass('hide'); }

      // asked for while the card was being rebuilt — open it on the new markup
      if(opts && opts.openNew && !quiet) d.openNew();
    },

    // Is this uuid one of ours? The signature channel is global — every signature
    // anywhere in the system reaches every open page — so the card must not be
    // refetched on somebody else's match.
    owns: function(uuid) {
      return (matchReport.data.disciplinarySignatures || []).indexOf(uuid) >= 0;
    },

    // Somebody signed on another device, or the people to choose from have
    // changed. Only this card is stale, so only this card is refetched:
    // reloading the page would throw away whatever the commissioner is typing in
    // the report around it.
    refresh: function(opts) {
      matchReport.disciplinary.send('GET', null, null, opts);
    },

    // The new-prijava form after the card has been re-rendered: the fresh markup
    // arrives with the form hidden, because that is the state a card is in until
    // somebody asks for it.
    openNew: function() {
      var $form = $('#disciplinary-new').removeClass('hide');
      $('.disc-intro').addClass('hide');
      $form.find('.js-disc-against').trigger('focus');
    }
  },

  describe: function(meta) {
    matchReport.data.meta = meta;
    matchReport.data.expanded = {};
    // per-question index, for the deviation tint on single rows
    matchReport.data.byQ = {};
    for(var key of Object.keys(meta.groups || {})) {
      for(var d of meta.groups[key]) {
        (matchReport.data.byQ[d.q] = matchReport.data.byQ[d.q] || []).push(d);
      }
    }
  },
  // What the rendered table would have to look like. A count is not enough: one
  // technical corrected away and another awarded in the same interval leaves the
  // count untouched while every row moves, and the DOM then holds rows bound to
  // array slots that no longer exist ("Cannot read properties of undefined").
  // The kind matters too — the mark's options differ for a player and a coach.
  foulSignature: function(con) {
    return JSON.stringify(['home', 'away'].map(function(side) {
      return (((con[side] || {}).fouls) || []).map(function(f) {
        return f ? [f.logId, f.fn, f.mark, f.readonly] : null;
      });
    }));
  },
  clearSave: function() {
    if(matchReport.data.saveTimeout) {
      clearTimeout(matchReport.data.saveTimeout);
    }
  },
  setSave: function() {
    matchReport.data.saveTimeout = setTimeout(function() {
      // Belt and braces. This guard was load-bearing under turbolinks, which kept
      // the JS process alive across navigations so a timer set here could fire with
      // another page's context. Turbolinks is off (docs/adr/0003-turbolinks-off.md)
      // and leaving the page now discards the timer with the process — but a 20s
      // timer that assumes what page it is on is worth one cheap check.
      if(typeof context !== 'undefined' && context && typeof context.reportJson === 'function') {
        context.save();
      }
    }, 20*1000);
  },
  initAfterLoad: function(report) {
    context = $.extend(context, report, {saving: false});
    matchReport.setSave();
  }
};
